import { OrdersByIdBeket } from 'shared/api/beket/my-orders/model'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

export const prepareOrderDetail = (orderInfo: OrdersByIdBeket | null) => {
  if (!orderInfo) {
    return null
  }
  const route = orderInfo?.travel_details.route

  const destination = `${route?.departure_station?.city} - ${route?.arrival_station?.city}`
  const carrier = orderInfo?.travel_details?.transport?.autobase

  return {
    destination,
    carrier,
    orderNum: orderInfo.order_no,
    totalPrice: orderInfo.total_price,
    expiredDate: orderInfo.expire_date,
    status: orderInfo.status,
    bonus: undefined,
  }
}

export const prepareOrderRoute = (orderInfo: OrdersByIdBeket | null) => {
  if (!orderInfo) {
    return null
  }
  return {
    departureTime: dateFormat(
      orderInfo?.travel_details.departure_datetime,
      DATE_FORMAT_LIST.TIME,
    ),
    departureDate: dateFormat(
      orderInfo?.travel_details.departure_datetime,
      DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY,
    ),
    departureCity: orderInfo?.travel_details.route.departure_station.city,
    departureAddress: orderInfo?.travel_details.route.departure_station.name,

    arrivalTime: dateFormat(
      orderInfo?.travel_details.arrival_datetime,
      DATE_FORMAT_LIST.TIME,
    ),
    arrivalDate: dateFormat(
      orderInfo?.travel_details.arrival_datetime,
      DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY,
    ),
    arrivalCity: orderInfo?.travel_details.route.arrival_station.city,
    arrivalAddress: orderInfo?.travel_details.route.arrival_station.name,
  }
}
